export default __webpack_public_path__ + "static/fonts/CamphorPro-Light.772a8d3.woff2";